<template>
    <div @keyup.esc="handleClose">
        <search-input
            :id="_uid"
            :clear-text="true"
            @keydown.up.prevent="handleUp"
            @keydown.down.prevent="handleDown"
            @keydown.enter="search"
            @input="suggest"
            v-model="query"
        />
        <suggestions
            :items="suggestions"
            :query="query"
            :id="_uid"
            v-if="! hasSuggestion && query.length > 2"
        />
        <results
            :items="results"
            :suggestedTopResults="topResults"
            :query="query"
            :id="_uid"
            :request-id="requestId"
            v-else
        />
    </div>
</template>

<script>
import $mediator from 'wee-mediator';
import debounce from 'lodash.debounce';
import SearchInput from '../input/index.vue';
import Suggestions from '../suggestions/index.vue';
import Results from '../results/index.vue';
import client from '../../../scripts/swiftypeClient';

export default {
    components: {
        SearchInput,
        Suggestions,
        Results,
    },
    mounted() {
        $mediator.on(`search-${this._uid}.clear`, () => {
            this.query = '';
            this.hasSuggestion = false;
            this.results = [];
            this.suggestions = [];
        });
    },
    methods: {
        handleClose() {
            $mediator.emit('search.desktop.close');
        },
        handleUp() {
            $mediator.emit(`search-${this._uid}.suggest-up`);
        },
        handleDown() {
            $mediator.emit(`search-${this._uid}.suggest-down`);
        },
        suggest: debounce(function() {
            if (this.query.length >= 2) {
                client.search(this.query, {
                    search_fields: {
                        title: {},
                    },
                    filters: {
                        none: [{
                            type: 'condition',
                        }],
                    },
                    result_fields: {
                        title: { raw: {} },
                        url: { raw: {} },
                    },
                    page: {
                        size: 10,
                    }
                }).then(({ results }) => {
                    this.suggestions = results;
                });
            }
        }, 100),
        search: debounce(function() {
            this.hasSuggestion = true;

            if (this.query.length > 2) {
                // Top Results array which matches the suggestions search
                client.search(this.query, {
                    search_fields: {
                        title: {},
                    },
                    filters: {
                        none: [{
                            type: 'condition',
                        }],
                    },
                    page: {
                        size: 200,
                    }
                }).then(({ results }) => {
                    this.topResults = results;
                });

                client.search(this.query, {
                    page: {
                        size: 200,
                    },
                    filters: {
                        none: {
                            type: 'condition',
                        },
                    },
                }).then(({ results, info }) => {
                    this.results = results;
                    this.info = info;
                    this.requestId = info.meta.request_id;
                });
            } else if (this.query.length === 0) {
                this.results = [];
                this.info = {};
            }
        }, 100),
    },
    data: () => ({
        query: '',
        hasSuggestion: false,
        results: [],
        topResults: [],
        suggestions: [],
        requestId: null,
        info: {},
    }),
};
</script>

